import React from 'react';
import { DODGER_BLUE } from '../../../Utils/Constants';

export const ChameleonRheostatHandle = ({ style, ...passProps }) => {
  return (
    <div
      {...passProps}
      style={{
        ...style,
        border: `1.5px solid ${DODGER_BLUE}`,
        borderRadius: '50%',
        cursor: 'pointer',
        marginTop: -5,
        height: 24,
        width: 24,
        zIndex: 3
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/Scss/Custom/RheostatSlider/ChameleonRheostatHandle.js